/**
 * Featured Updates Block
 * Controls tab functionality
 */
export default function featuredUpdates() {
    const tabBlocks = document.querySelectorAll('.js-tabs');

    // Check if there are any tab blocks on the page
    if (!tabBlocks.length) return;
    
    tabBlocks.forEach(tabBlock => {
        const tabButtons = tabBlock.querySelectorAll('.js-tab-button');
        const tabPanels = tabBlock.querySelectorAll('.js-tab-panel');
        
        // Add click event listeners to all tab buttons
        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const tabIndex = button.dataset.tab;
                
                // Deactivate all tabs
                tabButtons.forEach(btn => {
                    btn.classList.remove('is-active');
                    btn.setAttribute('aria-selected', 'false');
                });
                
                tabPanels.forEach(panel => {
                    panel.classList.remove('is-active');
                    panel.setAttribute('aria-hidden', 'true');
                });
                
                // Activate the selected tab
                button.classList.add('is-active');
                button.setAttribute('aria-selected', 'true');
                
                const activePanel = tabBlock.querySelector(`.js-tab-panel[data-tab="${tabIndex}"]`);
                if (activePanel) {
                    activePanel.classList.add('is-active');
                    activePanel.removeAttribute('aria-hidden');
                }
            });
        });
    });
}